export function selectOutlineFlow(attributes) {
  const {
    hasSidebar,
    sidebarAlignmentRight,
    hasSingleColumn,
    contentAlign,
    noSpacingBottom,
  } = attributes;
  if (noSpacingBottom) {
    return 'none';
  }

  if (hasSidebar) {
    return sidebarAlignmentRight ? 'right' : 'left';
  }

  if (hasSingleColumn) {
    switch (contentAlign) {
      case 'left':
        return 'right';
      case 'right':
        return 'left';
      default:
        break;
    }
  }

  return 'none';
}
